import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IDashBoardOrderDataRequest, IDashBoardOrderDataResponse } from '../models/models'

export class PostDashBoardOrderDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/dashBoardOrderData',
      requesterInfo,
    })
  }

  public async postDashBoardOrderData(request: IDashBoardOrderDataRequest): Promise<IDashBoardOrderDataResponse[]> {
    return await this.postAsync<IDashBoardOrderDataResponse[]>(request)
  }
}
